import React from 'react';
import FinancialForm from '../components/Shared/FinancialForm';
import FinancialTable from '../components/Shared/FinancialTable';

const Debts = ({ items, onAddItem, onUpdateStatus, loading }) => {
  return (
    <div>
      <h2>Controle de Dívidas</h2>
      <FinancialForm 
        onAddItem={onAddItem} 
        type="debt" 
      />
      {loading ? <p>Carregando...</p> : (
        <FinancialTable 
          items={items} 
          onUpdateStatus={onUpdateStatus} 
          type="debt" 
        />
      )}
    </div>
  );
};

export default Debts;